import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './initialState'

export const commonSlice = createSlice({
  name: 'Common',
  initialState,
  reducers: {
    clearAllStates: () => {},
    setDrawerVisible: (state, action) => {
      state.drawerVisible = action.payload
    },
  },
})
